<template>
  <div
    class="">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-select
                filled
                rounded
                dense

                color="#718EBF"
                placeholder="Contoh. 2023"

                hide-details

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header">
              <div
                class="fs-20 font-weight-bold">
                {{ form.id === '' ? 'Tambahkan Plafon' : 'Mengubah Plafon' }}
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.form = false; reset();"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="py-3 my-2 px-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                <ValidationProvider
                  name="Seles" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    Nama Sales
                  </div>

                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                    
                    filled
                    rounded
                    dense
                    solo
                    v-on:change="changeSales()"

                    color="#718EBF"
                    placeholder="Nama Sales"

                    
                    :items="sales"
                    item-value="id"
                    item-text="name"
                    :item-color="set_color"

                    v-model="form.sales_id"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </ValidationProvider>
                  <ValidationProvider
                    name="Customer" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Customer
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      v-on:change="fetchToko()"
                      :readonly="form.sales_id === ''"

                      color="#718EBF"
                      placeholder="Customer"

                      
                      :items="customer"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.customer_id"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Plafon" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Plafon
                    </div>

                    <v-currency-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Plafon"
                      v-model="form.new_value"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-currency-field>
                  </ValidationProvider> 

                  <ValidationProvider
                    name="Ketentuan" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Ketentuan
                    </div>

                    <v-textarea
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo
                      rows="2"

                      color="#718EBF"
                      placeholder="Ketentuan"
                      v-model="form.term"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-textarea>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Faktur" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Faktur
                    </div>

                    <v-text-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Faktur"
                      v-model="form.faktur"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Deskripsi" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->
                      Deskripsi
                    </div>

                    <v-textarea
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
                      solo

                      color="#718EBF"
                      placeholder="Deskripsi"
                      v-model="form.desc"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-textarea>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>


              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0">
              <v-spacer/>

              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>

              <!-- <v-btn 
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Hapus Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Plafon</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Hapus
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.status"
          v-if="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin <b class="font-weight-bold black--text">{{ message.status }}</b> Pengajuan Plafon?

                <div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      

                      <div
                        class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="approved_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="toStatus()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="1200"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pt-3">
            <v-card-title 
              class="d-flex align-center py-0 pb-2 text-right popup-header fs-16 font-weight-bold">
              
              Detail Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light pa-6 text-first line-text-second my-0 py-3 pt-0" v-if="Object.keys(detail).length > 0">
              <table style="width: auto;" class="mb-2">
                <tr>
                  <td class="fs-12">
                    Nama Customer
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.customer_name }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Nama Toko
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    <a target="_blank" :href="`/customer/data/detail/${detail.customer_id}`">
                      {{ store_name }} - {{ store_type }}
                    </a>
                  </td>
                </tr>
                <!-- <tr>
                  <td class="fs-12">
                    TOP
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.term === null || detail.term === '' ? '-' : detail.term }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Deskripsi
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.desc === null || detail.desc === '' ? '-' : detail.desc }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Faktur
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.faktur === null || detail.faktur === '' ? '-' : detail.faktur }}
                  </td>
                </tr> -->
                <tr>
                  <td class="fs-12">
                    TOP Lama
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: red !important;">
                    {{ detail.customer_term | number }} Hari
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    TOP Baru
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: green !important;">
                    <div v-if="detail.term === null || detail.term === '' || detail.term === 'null'">
                      -
                    </div>
                    <div v-if="detail.term !== null && detail.term !== '' && detail.term !== 'null'">
                      {{ detail.term | number }} Hari
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Faktur Lama
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: red !important;">
                    {{ detail.customer_faktur | number }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Faktur Baru
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: green !important;">
                    <div v-if="detail.faktur === null || detail.faktur === '' || detail.faktur === 'null'">
                      -
                    </div>
                    <div v-if="detail.faktur !== null && detail.faktur !== '' && detail.faktur !== 'null'">
                      {{ detail.faktur | number }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Plafon Lama
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: red !important;">
                    {{ detail.old_value | price }}
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Plafon Baru
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12" style="color: green !important;">
                    <div v-if="detail.new_value === null || detail.new_value === ''">
                      -
                    </div>
                    <div v-if="detail.new_value !== null && detail.new_value !== ''">
                      {{ detail.new_value | price }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="fs-12">
                    Status Approval
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : 'Ditolak'}}
                  </td>
                </tr>
                <!-- <tr>
                  <td class="fs-12">
                    Alasan
                  </td>
                  <td style="width: 40px" class="fs-12 text-center">
                    : 
                  </td>
                  <td class="text-left font-weight-bold fs-12">
                    {{ detail.rejected_reason }}
                  </td>
                </tr> -->
              </table>
              <!-- <v-row>
                <v-col>
                  <div>
                    <div>
                      Nama Customer
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.customer_name }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Nama Toko
                    </div>
                    <div class="fs-15 label-input">
                      {{ store_name }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Plafon Lama
                    </div>
                    <div class="fs-17 label-input font-weight-bold" style="color: red !important;">
                      {{ detail.old_value | price }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Plafon Baru
                    </div>
                    <div class="fs-17 label-input font-weight-bold" style="color: green !important;">
                      {{ detail.new_value | price }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Faktur
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.faktur }}
                    </div>
                  </div>
                </v-col>

                <v-col>
                  <div>
                    <div>
                      Ketentuan
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.term }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Deskripsi
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.desc === null || detail.desc === '' ? '-' : detail.desc }}
                    </div>
                  </div>
                  <div>
                    <div>
                      Status Approval
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : 'Ditolak'}}
                    </div>
                  </div>
                  <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div>
                  
                </v-col>
              </v-row> -->

              <v-row v-if="detail.status !== 'rejected'">

                <v-col cols="12" md="4" class="pt-0">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px; border: 1px solid #E7E7E7;">
                    <!-- <div class="d-flex pa-3" style="width: 100%;" :style="`background-color: ${set_color}`">
                      <div class="fs-12 font-weight-bold text-capitalize white--text">
                        Supervisor
                      </div>
                      <div class="ml-auto" v-if="detail.customer_plafon_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_plafon_approval.Supervisor.length < 1">
                        <v-checkbox
                          v-model="approved_by"
                          value="Supervisor"
                          v-on:change="toChange()"
                          color="white"
                          style="color: white !important"
                          hide-details
                        ></v-checkbox>
                      </div>
                    </div> -->
                    <v-toolbar
                      :color="set_color"
                      dense
                      dark>
                      <v-toolbar-title class="fs-12 font-weight-bold text-capitalize">
                        Supervisor
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                      <div v-if="detail.customer_plafon_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_plafon_approval.Supervisor.length < 1">
                        <v-checkbox
                          v-model="approved_by"
                          value="Supervisor"
                          v-on:change="toChange()"
                          color="white"
                          style="color: white !important"
                          hide-details
                        ></v-checkbox>
                      </div>

                    </v-toolbar>

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      Supervisor
                    </v-card-text> -->

                    <v-card-text class="fs-12 font-weight-light text-first py-2 px-3">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ detail.customer_plafon_approval.Supervisor.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager' ? detail.customer_plafon_approval.General_Manager[0].user_name : '-' : detail.customer_plafon_approval.Supervisor[0].user_name }}</b>
                        </span>
                      </p>

                      <p class="mb-0">
                        <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                        <span>
                          <b v-if="detail.customer_plafon_approval.Supervisor.length > 0">{{  detail.customer_plafon_approval.Supervisor[0].customer_plafon_approval_datetime | datetime  }}</b>
                          <b v-else>
                            <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager'">
                              {{  detail.customer_plafon_approval.General_Manager[0].customer_plafon_approval_datetime | datetime  }}
                            </span>
                            <span v-else>
                              -
                            </span>
                          </b>
                        </span>
                      </p>

                      <div v-if="detail.approved_reason.name === 'Supervisor' || detail.approved_reason.name === 'all'"  class="mt-2 fs-12">

                        <div>
                          Alasan Approve
    
                        </div>
                        <div class="fs-12 label-input">
                          {{ detail.approved_reason.reason }}
                        </div>
                      </div>


                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4" class="pt-0">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px; border: 1px solid #E7E7E7;">
                    <v-toolbar
                      :color="set_color"
                      dense
                      dark>
                      <v-toolbar-title class="fs-12 font-weight-bold text-capitalize">
                        Sales Manager
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                      <div v-if="detail.customer_plafon_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_plafon_approval.Sales_Manager.length < 1">
                        <v-checkbox
                          v-model="approved_by"
                          color="white"
                          :disabled="detail.customer_plafon_approval.Supervisor.length < 1 ? approved_by.length > 0 ? false : true : false"
                          value="Sales Manager"
                          hide-details
                        ></v-checkbox>
                      </div>

                    </v-toolbar>

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      Sales Manager
                    </v-card-text> -->

                    <v-card-text class="fs-12 font-weight-light text-first py-2 px-3">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ detail.customer_plafon_approval.Sales_Manager.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager' ? detail.customer_plafon_approval.General_Manager[0].user_name : '-' : detail.customer_plafon_approval.Sales_Manager[0].user_name }}</b>
                        </span>
                      </p>

                      <p class="mb-0">
                        <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                        <span>
                          <b v-if="detail.customer_plafon_approval.Sales_Manager.length > 0">{{  detail.customer_plafon_approval.Sales_Manager[0].customer_plafon_approval_datetime | datetime  }}</b>
                          <b v-else>
                            <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager'">
                              {{  detail.customer_plafon_approval.General_Manager[0].customer_plafon_approval_datetime | datetime  }}
                            </span>
                            <span v-else>
                              -
                            </span>
                          </b>
                        </span>
                      </p>

                      <div v-if="detail.approved_reason.name === 'Sales Manager' || detail.approved_reason.name === 'all'" class="mt-2 fs-12">

                        <div>
                          Alasan Approve
    
                        </div>
                        <div class="fs-16 label-input">
                          {{ detail.approved_reason.reason }}
                        </div>
                      </div>



                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4" class="pt-0">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px; border: 1px solid #E7E7E7;">
                    <v-toolbar
                      :color="set_color"
                      dense
                      dark>
                      <v-toolbar-title class="fs-12 font-weight-bold text-capitalize">
                        General Manager
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                      

                    </v-toolbar>

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      General Manager
                    </v-card-text> -->

                    <v-card-text class="fs-12 font-weight-light text-first py-2 px-3">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ detail.customer_plafon_approval.General_Manager.length < 1 ? '-' : detail.customer_plafon_approval.General_Manager[0].user_name }}</b>
                        </span>
                      </p>

                      <p class="mb-0">
                        <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                        <span>
                          <b v-if="detail.customer_plafon_approval.General_Manager.length > 0">{{  detail.customer_plafon_approval.General_Manager[0].customer_plafon_approval_datetime | datetime  }}</b>
                          <b v-else>-</b>
                        </span>
                      </p>


                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="detail.status === 'rejected'">
                <v-col cols="12" md="4">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px; border: 1px solid #E7E7E7;">
                    <v-toolbar
                      :color="set_color"
                      dark>
                      <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                        Staff yg Menolak
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                      <!-- <div v-if="detail.customer_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_approval.Supervisor.length < 1">
                        <v-checkbox
                          v-model="approve_name"
                          v-on-change="$emit('approved', approve_name)"
                          value="Supervisor"
                          color="white"
                          style="color: white !important"
                          hide-details
                        ></v-checkbox>
                      </div> -->

                    </v-toolbar>

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      Supervisor
                    </v-card-text> -->

                    <v-card-text class="body-2 font-weight-light text-first">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ detail.user_rejected_name }}</b>
                        </span>
                      </p>

                      <p class="mb-2">
                        <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                        <span>
                          <b>{{ detail.rejected_date | date  }}</b>
                        </span>
                      </p>


                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>


              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-6 pt-4 pb-2">
              <v-spacer/>

              <div
              v-if="detail.customer_plafon_approval !== undefined && Object.keys(detail.customer_plafon_approval).length > 0 && detail.status === 'proses'">
              
              <div
                  v-if="user.category_user_title === 'Supervisor' && detail.customer_plafon_approval.Supervisor.length < 1 && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Supervisor,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="35"
                    elevation="0"
                    color="#1814F3"
                    
                    style="border-radius: 6px;"
                    class="fs-12 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="resetTolak(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="35"
                    elevation="0"
                    color="warning"
                    
                    style="border-radius: 6px;"
                    class="fs-12 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Sales Manager' && detail.customer_plafon_approval.Sales_Manager.length < 1 && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Sales Manager,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="35"
                    elevation="0"
                    color="#1814F3"
                    
                    style="border-radius: 6px;"
                    class="fs-12 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="resetTolak(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="35"
                    elevation="0"
                    color="warning"
                    
                    style="border-radius: 6px;"
                    class="fs-12 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>
                </div>
                
                <div
                  v-else-if="user.category_user_title === 'General Manager' && detail.customer_plafon_approval.General_Manager.length < 1"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="35"
                    elevation="0"
                    color="#1814F3"
                    style="border-radius: 6px;"
                    class="fs-12 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="resetTolak(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="35"
                    elevation="0"
                    color="warning"
                    style="border-radius: 6px;"
                    class="fs-12 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>  
                </div>
              </div>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-card 
            flat
            class=""
            style="border-radius: 10px;">

            <v-row
              class="pa-0">
              <v-col
                cols="12"
                md="12"
                class="d-flex align-center">
                <!-- <v-btn
                  color="#4B4B4B"
                  elevation="0"
                  :disabled="process.load"
                  @click="dialog.form = true; reset();"
                  class="body-2 white--text text-capitalize d-flex align-center ml-0"
                  style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn> -->
                <!-- <v-text-field
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line

                  hide-details
                  :color="set_color"
                  placeholder="Cari data yang Anda butuhkan . . ."
                  append-icon="mdi-magnify"
                  clearable

                  v-model="search"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                </v-text-field> -->

                <!-- FREEZE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div> -->

                <!-- HIDE COLUMN -->
                <!-- <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div> -->
              </v-col>
            </v-row>

            <v-card 
              flat
              class=""
              style="border-radius: 25px; border: 1px solid #E7E7E7;">
              <div class="view">
                <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                  <table style="border-radius: 10px; width: 100%;" class="table">
                    <tr>
                      <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">No</th>
                      <th @click="sortBy !== 'create_datetime' ? toSort('create_datetime') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Tanggal
                        <span v-if="sortBy === 'create_datetime'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Type
                      </th>
                      <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Keterangan
                      </th>
                      <!-- <th @click="sortBy !== 'status' ? toSort('status') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        Status
                        <span v-if="sortBy === 'status'">
                          <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                          <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                        </span>
                      </th> -->
                    </tr>
                    <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                      <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                        {{ index + 1 + (paginationList.page - 1) * paginationList.row }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: left;">{{ (item.date) | date }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: left;">
                        <div class="fs-12">
                          {{ item.type_perubahan }}
                        </div>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; width: 1px; white-space: nowrap; text-align: left;">
                        <div class="fs-12" v-if="item.type_perubahan === 'Plafon'">
                          <div v-if="item.old_value !== item.new_value" class="text-first">
                            merubah Plafon dari {{ item.old_value | price }} ke {{ item.new_value | price }}
                          </div>
                          <div v-if="item.customer_faktur !== item.faktur && item.faktur !== null && item.faktur !== 'null'" class="text-first">
                            merubah Faktur dari {{ item.customer_faktur }} ke {{ item.faktur }}
                          </div>

                          <div v-if="item.customer_term !== item.term && item.term !== null && item.term !== 'null'" class="text-first">
                            merubah TOP dari {{ item.customer_term }} hari ke {{ item.term }} hari
                          </div>
                        </div>

                        <div class="fs-12" v-if="item.type_perubahan === 'Perubahan Data'">
                          <a target="_blank" :href="`/customer/perubahan/detail/${item.id}`">
                            Ada Perubahan Data
                          </a>
                        </div>
                      </td>
                      <!-- <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                        {{ item.status === 'proses' ? 'Diproses' : item.status === 'approved' ? 'Diterima' : 'Ditolak'}}
                      </td> -->
                    </tr>
                  </table>
                </div>

                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <v-card-text
                  v-if="list.length === 0"
                  class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-16">
                      Belum Ada Data
                    </div>
                  </div>
                </v-card-text>

                <!-- <pagination v-if="!process.load && pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/> -->

              </div>


              <!-- <pagination v-if="pagination.total_data > 0"
                @changePage="fetch($event)" 
                @reloadPage="fetch($event)" 
                :model="pagination"/> -->
            </v-card>
          </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {

        approved_by: [],
        approved_reason: '',
        checkbox: false,
        tabs: 0,
        tab: [
          {
            title: 'Diproses',
            id: 'proses'
          },
          {
            title: 'Diterima',
            id: 'approved'
          },
          {
            title: 'Ditolak',
            id: 'rejected'
          }
        ],

        rejected_reason: '',

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          detail: false,
          status: false
        },
        
        search: '',

        filter: {
          year: new Date().getFullYear()
        },

        selected: {
          freeze: [],
          delete: [],
          row: []
        },

        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        form: {
          id: '',
          sales_id: '',
          customer_id: '',
          old_value: '',
          new_value: '',
          term: '',
          faktur: '',
          desc: ''
        },

        detail: {},

        customer: [],
        toko: [],
        sales_region_id: '',

        sales: [],

        plafon: [],
        perubahan_data: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {
          page: 1,
          row: 50
        },
        store_name: '',
        store_id: '',
        store_type: '',

        lastIndex: 0,
        limit: 50,
        sortBy: 'id',
        sortDesc: '-',

        process: {
          load: false,

          delete: false
        },
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      // this.fetchSales()
      this.fetch()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },
      toChange () {
        if(this.approved_by.length > 0 && this.approved_by[0] === 'Sales Manager') {
          this.approved_by = [] 
        }
        // this.$emit('approved', this.approve_name)
      },
      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          is_active: 'Aktif',
          limit: 1000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.form.id
        }

        await get(`admin/customer_plafon/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.detail.approved_reason = this.detail.approved_reason.length < 1 ? { name: '', reason: '' } : JSON.parse(this.detail.approved_reason)
            
          }
          this.process.load = false
        })
      },
      async fetchCustomor () {
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 10000000000000,
          sales_region_id: this.sales_region_id
        }

        // admin/services/data
        
        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          
          if (res.status === 200) {
            this.customer = res.results.data
            // if (this.form.id !== '') {
            //   this.fetchEditToko()
            // }
          }
        })
      },
      async fetchToko() {
        this.customer.map(obj => {
          if (obj.id === this.form.customer_id) {
            this.form.old_value = obj.plafon
          }
        })
      },
      // async fetchEditToko() {
        
      //   this.toko = []
      //   let params = {
      //     id: this.form.customer_id
      //   }
  
      //   await get('admin/customer/detail', { params })
      //   .then(response => {
      //     let res = response.data
            
      //     if (res.status === 200) {
      //       this.toko = res.results.data.store
      //     }
      //   })
      // },
      changeSales() {
        this.sales.map(obj => {
          if (obj.id === this.form.sales_id) {
            this.sales_region_id = obj.sales_region_id
          }
        })

        this.fetchCustomor()
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      async fetch (pagination = { row: 1000, page: 1 }) {
        this.process.load = true
        this.paginationList= {
          page: pagination.page,
          row: pagination.row
        }

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          sort: `-id`,
          customer_id: this.$route.params.id
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/customer_plafon/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.plafon = []
            res.results.data.map(obj => {
              this.plafon.push({
                ...obj,
                type_perubahan: 'Plafon'
              })
            })
            this.fetchPerubahanData()
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      async fetchPerubahanData (pagination = { row: 1000, page: 1 }) {
        this.process.load = true
        this.paginationList= {
          page: pagination.page,
          row: pagination.row
        }

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          sort: `-id`,
          customer_id: this.$route.params.id
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/customer_edit/data_change`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.perubahan_data = []
            res.results.data.map(obj => {
              this.perubahan_data.push({
                ...obj,
                type_perubahan: 'Perubahan Data'
              })
            })
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.list = [...this.plafon, ...this.perubahan_data];

            // Urutkan berdasarkan tanggal terbaru ke terlama
            this.list.sort((a, b) => new Date(b.date) - new Date(a.date));
            console.log(this.list)

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      resetTolak() {
        this.rejected_reason = ''
        if (this.$refs.form) this.$refs.form.reset()

      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        this.approved_by = []
        this.approved_reason = ''
        
        this.sales_region_id = ''
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          sales_id: index !== undefined ? this.list[index].sales_id : '',
          customer_id: index !== undefined ? this.list[index].customer_id : '',
          old_value: index !== undefined ? this.list[index].old_value : '',
          new_value: index !== undefined ? this.list[index].new_value : '',
          term: index !== undefined ? this.list[index].term : '',
          faktur: index !== undefined ? this.list[index].faktur : '',
          desc: index !== undefined ? this.list[index].desc : ''
        }

        this.rejected_reason = ''

        if (index !== undefined) {
          this.changeSales()
          this.detail = this.list[index]
        }
        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/customer_plafon/submission_plafon' : 'admin/customer_plafon/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch(this.paginationList)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async toStatus () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? this.approved_by.length > 0 ? await this.$refs.form.validate() : true : await this.$refs.form.validate()

        if (isValid) {

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 
        }

        await post(`admin/customer_plafon/approval`, {
          data: {
            id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected',
            approved_by: this.message.status === 'terima' ? this.approved_by.length < 1 ? this.user.category_user_title === 'General Manager' ? this.detail.approved_by === 'Supervisor,Sales Manager' ? `Supervisor,Sales Manager,General Manager` : this.detail.approved_by === 'Supervisor' ? `Supervisor,General Manager` : this.detail.approved_by === 'Sales Manager' ? `Sales Manager,General Manager` : this.user.category_user_title : this.user.category_user_title : this.approved_by.length === 1 ? this.detail.approved_by === '' ? `${this.approved_by[0]},General Manager` :  `Supervisor,Sales Manager,General Manager` : `Supervisor,Sales Manager,General Manager` : '',
            approved_reason: this.detail.approved_reason.name === '' ? JSON.stringify(approved_reason) : JSON.stringify(this.detail.approved_reason),
            rejected_reason: this.rejected_reason
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/customer_plafon/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 310px); 
} 

.wrapper-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>